import { defineStore } from 'pinia';
import PromoService from '@/services/PromoService';

export const promoStore = defineStore('promo', {
  // Codes staan niet in de pagina: elke code wordt op de server nagekeken.
  actions: {
    async validatePromocode(code) {
      try {
        const response = await PromoService.validatePromocode(code);
        if (response.data.valid) {
          return {
            success: true,
            promo: response.data.promo,
          };
        } else {
          return {
            success: false,
            error: response.data.error,
          };
        }
      } catch (error) {
        return {
          success: false,
          error:
            error.response?.data?.error ||
            'Er ging iets mis bij het valideren van de promocode',
        };
      }
    },
  },
});
